@if (isToday && isNotDE()) {
  <span class="red">{{ dateToShow }}</span>
} @else {
  @if (newsDate()) {
    <span>{{ HELPER.formatDateWithLocalizedMonth(newsDate()) }}</span>
  }
}
